import { connect } from 'react-redux';
import { TeamTable } from './component';
import { mapStateToProps } from './redux';


export default connect(mapStateToProps, null)(TeamTable);
